module.exports = __webpack_public_path__ + "52764ee9f90c0bd9e9c210501bed61cc.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/big-frog-logo.png
// module id = 563
// module chunks = 16